import React, { memo } from "react";
import classNames from "classnames";
import { Date as DateComponent, ListGroupItem } from "components/Shared";
// @ts-ignore
import filesize from "filesize";
import _ from "lodash";

interface Props {
	form: any;
	onRemove?: () => void;
}

const FormItem = ({ form, onRemove }: Props) => {
	const title = form.name || form.display_code || form.code;
	// `created_by_name` is a flat scalar from FormSerializer (see note there on
	// why it isn't named `created_by`). Fall back to the relationship object if a
	// caller ever provides one.
	const user =
		form.created_by_name || _.get(form, "created_by.full_name") || _.get(form, "created_by.firstname");
	const size = form.filesize_bytes ? filesize(form.filesize_bytes || 0, { round: 1 }) : null;

	return (
		<ListGroupItem
			heading={title}
			// Mirror the Documents tab card layout: author + created date live in
			// the heading block (secondHeading / subheading), and the file size is a
			// bare datapoint. This keeps Forms and Documents visually consistent.
			secondHeading={user}
			subheading={form.created_at ? <DateComponent date={form.created_at} /> : false}
			icon={<i className={classNames("document-icon", "far", "fa-file-word")} />}
			// Click goes to the in-app preview page (Google Docs viewer for the
			// .docx) — same UX as clicking a Document. Download is offered from
			// inside that page's header toolbar.
			link={`/forms/${form.id}`}
			onRemove={onRemove}
			className={["document", "form-item"]}
			datapoints={[size ? size : null]}
		/>
	);
};

export default memo(FormItem);
